<div id="open-duration-container">
  <div class="top-row">
    <span class="energyToolWidgetTitle">{{ "energy_tool.open_duration.time_open" | translate }}</span>
  </div>
  @if (!noData()) {
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    } @else {
      <div id="open-duration-content">
        <div class="row">
          <span class="duration-label">{{ "energy_tool.open_duration.current_time_open" | translate }}</span>
          <div class="duration-kpi">
            <span>{{ timerDisplay()?.value || "" | translate }}</span>
            <span>{{ timerDisplay()?.unit || "" | translate }}</span>
          </div>
        </div>
        <div class="row">
          <span class="duration-label">{{ "energy_tool.open_duration.last_time_open" | translate }}</span>
          <div class="duration-kpi">
            <span>{{ displayLastOpenDuration()?.value }}</span>
            <span>
              {{ displayLastOpenDuration()?.unit || "" | translate }}
            </span>
          </div>
        </div>
        <div class="row">
          <span class="duration-label">{{ "energy_tool.open_duration.longest_time_open" | translate }}</span>
          <div class="duration-kpi">
            <span>{{ displayLongestOpenDuration()?.value }}</span>
            <span>{{ displayLongestOpenDuration()?.unit || "" | translate }}</span>
          </div>
        </div>
      </div>
    }
  } @else {
    <span>{{ "common.no_data" | translate }}</span>
  }
</div>
